import render from 'preact-render-to-string';
import { Link, route } from 'preact-router';
import Table from "../components/ui/Table";
import useApp from '../context/AppContext';

export default function EventsTypeList() {
    const { eventsType } = useApp();
    const columns = [
        { label: "Nom", accessor: "name", sortable: true },
    ];

    function cellFormat(value, accessor, data) {
        let str = value;
        switch (accessor) {
            case 'name':
                str = render(<Link href={'/event-type/' + data.id}>{value}</Link>);
                break;
            default:
        }
        return str;
    }

    function onClick() {
        route('/event-type/');
    }

    return (
        <div>
            <Table id="events-type" caption="Liste des évènements type" columns={columns} selectable={false} cellFormat={cellFormat} data={eventsType} />
            <input class="action-button btn btn-primary position-fixed bottom-0 end-0 me-3 mb-3" type="button" value="Ajouter un évènement type" onClick={onClick} />
        </div>
    );
}